import { gql } from '@provision/graphql-client';

export const GET_LANDING_PAGE_CONFIG_QUERY = gql`
  query GetBundledLandingPageConfig($input: GetBundledLandingPageConfigInput!) {
    getBundledLandingPageConfig(input: $input) {
      id
      name
      slug
      isDefault
      isActive
      config
    }
  }
`;

export const SAVE_LANDING_PAGE_CONFIG_MUTATION = gql`
  mutation SaveLandingPageConfig($input: SaveLandingPageConfigInput!) {
    saveLandingPageConfig(input: $input) {
      success
    }
  }
`;
